import { createReducer } from '@mews/framework';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    FORM_MODE_SETUP,
    FORM_RELATED_ENTITIES_FETCH_SUCCEEDED,
    RESTRICTION_FORM_INIT_FAILED,
    RESTRICTION_FORM_INIT_STARTED,
    RESTRICTION_FORM_INIT_SUCCEEDED,
} from '../actionTypes';

const INITIAL_STATE = {
    lastFetchedEntitiesTimestamp: null,
};

const formReducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [FORM_MODE_SETUP]: (state, payload) => ({
        ...state,
        ...payload,
    }),

    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [FORM_RELATED_ENTITIES_FETCH_SUCCEEDED]: (state, lastFetchedEntitiesTimestamp) => ({
        ...state,
        lastFetchedEntitiesTimestamp,
    }),
    ...createEntityAsyncMetaHandlers({
        STARTED: RESTRICTION_FORM_INIT_STARTED,
        SUCCEEDED: RESTRICTION_FORM_INIT_SUCCEEDED,
        FAILED: RESTRICTION_FORM_INIT_FAILED,
    }),
});

export default formReducer;
